import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import styles from "./intro.module.css";
var Intro = function(blok) {
    var trackEvent = useAnalytics().trackEvent;
    var ref = _sliced_to_array(blok.CTA || [], 1), CTA = ref[0];
    // Doing this because it complains if we add target directly, however it works
    var link = {
        target: "_blank"
    };
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        className: styles.container,
        children: [
            renderWithResolver(blok.body),
            CTA ? /*#__PURE__*/ _jsx(Primary, _object_spread_props(_object_spread({
                element: "a"
            }, link), {
                href: CTA.url,
                onClick: function() {
                    trackEvent({
                        eventName: "Partnerships - cinch presents site click",
                        data: {
                            event: {
                                name: "click",
                                category: "parnerships pages",
                                action: "partnerships tags",
                                label: "Visit cinch presents site"
                            }
                        },
                        type: TrackingEventTypes.ADOBE
                    });
                },
                classNames: {
                    button: styles.button
                },
                children: CTA.text
            })) : null
        ]
    }));
};
export default Intro;
